
const addressSet = {
    BNB: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
    BUSD: "0xe9e7cea3dedca5984780bafc599bd69add087d56",
    USDT: "0x55d398326f99059ff775485246999027b3197955",
    USDC: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
    Dai: "0x1af3f329e8be154074d8769d1ffa4ee058b1dbc3",
    ETH: "0x2170ed0880ac9a755fd29b2688956bd959f933f8",
    // PAX: "0xb7f8cd00c5a06c0537e2abff0b58033d02e5e094",
    SquidMuun: "0xe6c14c144ce8d53cb9bb5d4669009a27e55d057b"
}

const walletSet = [

    {name: 'MINU', addr: "0xea5e9f39f4b4bc2684e49a0e43127f7f6f6be3b8"},
    {name: 'SquidMuun', addr: "0xe6c14c144ce8d53cb9bb5d4669009a27e55d057b"},
    // {name: 'USDT', addr: "0x55d398326f99059fF775485246999027B3197955"}
]

const swapSet = [
    {name: 'BNB', addr:"0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c"},
    {name: 'BUSD', addr: "0xe9e7cea3dedca5984780bafc599bd69add087d56"},
    {name: 'USDT', addr: "0x55d398326f99059ff775485246999027b3197955"},
    {name: 'USDC', addr: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d"},
    {name: 'Dai', addr: "0x1af3f329e8be154074d8769d1ffa4ee058b1dbc3"},
    {name: 'ETH', addr: "0x2170ed0880ac9a755fd29b2688956bd959f933f8"},
    // {name: 'PAX', addr: "0xb7f8cd00c5a06c0537e2abff0b58033d02e5e094"},
    {name: 'SquidMuun', addr: "0xe6c14c144ce8d53cb9bb5d4669009a27e55d057b"}
]

const pairaddressSet= {
    BUSD_BNB: "0x58F876857a02D6762E0101bb5C46A8c1ED44Dc16",
    BNB_BUSD: "0x58F876857a02D6762E0101bb5C46A8c1ED44Dc16",
    USDT_BNB: "0x16b9a82891338f9bA80E2D6970FddA79D1eb0daE",
    BNB_USDT: "0x16b9a82891338f9bA80E2D6970FddA79D1eb0daE",
    USDC_USDT: "0xec6557348085aa57c72514d67070dc863c0a5a8c",
    USDT_USDC: "0xec6557348085aa57c72514d67070dc863c0a5a8c",
    USDC_BUSD: "0x2354ef4DF11afacb85a5C7f98B624072ECcddbB1",
    BUSD_USDC: "0x2354ef4DF11afacb85a5C7f98B624072ECcddbB1",
    USDT_BUSD: "0x7EFaEf62fDdCCa950418312c6C91Aef321375A00",
    BUSD_USDT: "0x7EFaEf62fDdCCa950418312c6C91Aef321375A00",
    Dai_BUSD: "0x66FDB2eCCfB58cF098eaa419e5EfDe841368e489",
    BUSD_Dai: "0x66FDB2eCCfB58cF098eaa419e5EfDe841368e489",
    BNB_SquidMuun: "0xA3baC43045B0D60edD095cCA9E46F7b65604C8FB",
    SquidMuun_BNB: "0xA3baC43045B0D60edD095cCA9E46F7b65604C8FB",
    ETH_USDC: "0xEa26B78255Df2bBC31C1eBf60010D78670185bD0",
    USDC_ETH: "0xEa26B78255Df2bBC31C1eBf60010D78670185bD0",
    ETH_BNB: "0x74E4716E431f45807DCF19f284c7aA99F18a4fbc",
    BNB_ETH: "0x74E4716E431f45807DCF19f284c7aA99F18a4fbc"
}

module.exports = {
    addressSet,
    walletSet,
    swapSet,
    pairaddressSet
};